import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 控制左右板块是否显示
    bothEndsShow:true,
    // 请求参数使用token值
    tokenData:{},
  },
  getters: {
    getToken(state){
      return state.tokenData.token
    },
  },
  mutations: {
    setBothEndsShow(state){
      state.bothEndsShow = !state.bothEndsShow
    },
    setToken(state,val){
      state.tokenData = {...val}
    },
  },
  actions: {
  },
  modules: {
  }
})
